import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import tw, { styled } from "twin.macro";
import {
  flatMenuToHierarchical,
  stripPhoneNumber,
  toggleScroll,
} from "../../lib/functions";

import Logo from "./Logo";
import MobileNavigation from "./MobileNavigation";
import HomeDesktopNavigation from "./HomeDesktopNavigation";
import DesktopNavigation from "./DesktopNavigation";

const Container = styled.header(({ inner }) => [
  tw`fixed py-0 flex flex-row h-24 z-excessive bg-dark items-center justify-between shadow-lg  xl:(h-auto pt-4 pb-2 absolute px-8 items-start bg-transparent shadow-none) top-0 left-0 w-full max-w-full pl-4`,
  inner && tw`xl:(flex-col fixed bg-dark shadow-lg )`,
]);

const Top = styled.div(({ inner }) => [
  tw`lg:flex-row flex flex-row-reverse items-center justify-between w-full`,
  inner && tw`xl:justify-end`,
]);

const Bottom = styled.div(
  tw`bg-dark xl:(flex mt-12) flex-col items-center justify-center hidden w-full `
);

const PhoneNumber = tw.a`tracking-widest font-gothic uppercase hidden lg:flex text-primary text-3xl transition-colors duration-500 ease-in-out hover:text-white `;
const Button = tw.button`w-24 focus:animate-ping relative h-full flex flex-col items-center justify-center xl:hidden`;
const Line = styled.div`
  ${tw`w-10 h-0.5 bg-white xl:hidden`}
  &:not(:nth-child(1)) {
    ${tw`mt-1.5`}
  }
  &:nth-child(2) {
    ${tw`transform translate-x-2`}
  }
`;

const Header = ({ inner }) => {
  const { wp, allWpMenuItem } = useStaticQuery(graphql`
    {
      allWpMenuItem(
        filter: { menu: { node: { locations: { eq: MAIN_MENU } } } }
      ) {
        nodes {
          label
          id
          path
          parentId
          target
        }
      }
      wp {
        esquireAcf {
          firmInformation {
            mainNumber
          }
        }
      }
    }
  `);
  if (!allWpMenuItem?.nodes)
    throw new Error(
      "No main menu found. Did you set a menu in WordPress with the location main-menu?"
    );
  const [mobileMenuOpen, setMobile] = useState(false);
  const { mainNumber } = wp.esquireAcf.firmInformation;
  const menu = flatMenuToHierarchical(allWpMenuItem.nodes);
  const isHome = !inner;

  return (
    <Container inner={inner}>
      <Top inner={inner}>
        {isHome && <HomeDesktopNavigation menu={menu} />}
        <Button
          aria-label="Open mobile menu"
          tabIndex="0"
          onClick={() => {
            setMobile(true);
            toggleScroll();
          }}
        >
          {Array(3)
            .fill()
            .map((_, i) => (
              <Line key={i} />
            ))}
        </Button>
        <Logo to="/" tw="w-[75%] lg:(absolute mx-auto left-0 right-0 top-4)" />
        <PhoneNumber href={`tel: ${stripPhoneNumber(mainNumber)}`}>
          {mainNumber}
        </PhoneNumber>
      </Top>
      {!isHome && (
        <Bottom>
          <DesktopNavigation menu={menu} />
        </Bottom>
      )}
      <MobileNavigation
        open={mobileMenuOpen}
        onClose={() => {
          setMobile(false);
          toggleScroll();
        }}
        menu={menu}
      />
    </Container>
  );
};

export default Header;
